import { BREAKPOINTS } from '../constants/breakpoints';
import { useMediaQuery } from './use-media-query';

/**
 * Determines whether the viewport has a width of a
 * medium-sized mobile or smaller.
 *
 * @returns boolean
 */
export const useIsMobile = () => {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.MOBILE}px)`);

  return isMobile;
};
